var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie-chart-wrapper"},[_c('RevenueAndProfitPieChart',{attrs:{"pieChartData":_vm.pieChartData}}),_c('vue-element-loading',{attrs:{"active":_vm.isLoading,"color":"#888"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }